<template>
  <ion-content>
    <ion-item button detail="false" lines="none" @click="$store.dispatch('options/update', { showCompleted: !showCompleted })">
      <ion-label v-tl:OPTIONS_SHOW_COMPLETED />
      <ion-toggle :checked="showCompleted" />
    </ion-item>
    <ion-item button detail="false" lines="none" @click="$store.dispatch('options/update', { showArchived: !showArchived })">
      <ion-label v-tl:OPTIONS_SHOW_ARCHIVED />
      <ion-toggle :checked="showArchived" />
    </ion-item>
  </ion-content>
</template>

<script>
import {
    IonContent,
    IonToggle,
    IonItem,
    IonLabel,
} from '@ionic/vue';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'OptionsPopover',
    components: {
        IonContent,
        IonToggle,
        IonItem,
        IonLabel,
    },
    computed: {
        showCompleted() {
            return this.$store.state.options.showCompleted;
        },
        showArchived() {
            return this.$store.state.options.showArchived;
        },
    },
});
</script>